module.exports = __webpack_public_path__ + "static/media/equalicare-img21.7aa5c520.png";